<template>
  <div class="pt-3">
    <v-form ref="sindicateMandateForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
      <v-layout row wrap white align-end>
        <v-flex xs3 pl-4>
          <v-menu
            v-model="initDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_init_formated"
                label="Data inicial"
                return-masked-value
                mask="##/####"
                clearable
                v-on="on"
                :rules="$store.state.formRules.required"
              ></v-text-field>
            </template>
            <v-date-picker type="month" no-title v-model="date_init" @input="initDateMenu = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs3 pl-4>
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_end_formated"
                label="Data final"
                return-masked-value
                mask="##/####"
                clearable
                v-on="on"
                :rules="$store.state.formRules.required"
              ></v-text-field>
            </template>
            <v-date-picker type="month" no-title v-model="date_end" @input="endDateMenu = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs4 pl-4>
          <v-autocomplete
            clearable
            v-model="condominium_id"
            :items="condominiumsList"
            item-text="name_fantasy"
            item-value="id"
            label="Selecione o condomínio"
          >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                class="autocomplete-text-truncate-class"
              >
                <v-avatar>
                  <img :src="data.item.avatar" />
                </v-avatar>
                {{ data.item.name_fantasy }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <template v-if="checkType(data)">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <img :src="data.item.avatar" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="data.item.name_fantasy"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="data.item.name_company"
                  ></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </template>
            <template v-slot:append-outer>
              <v-icon @click="searchMandates">search</v-icon>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex class="xs12">
          <h2 class="title mx-4 mt-4 mb-1 text-xs-left" style="font-weight:400;">Lista de mandatos</h2>
        </v-flex>
        <v-flex xs2 pt-3 pb-2 mt-1 pl-3 v-if="mandates.length">
          <!-- <ListPdf v-if="typeDocs.length" /> -->
          <v-btn small color="blue darken-1" class="white--text pr-3 mt-2" @click="generateReport">
            <v-icon class="mr-2" style="font-size:20px;" left dark>print</v-icon>Pdf para impressão
          </v-btn>
          <vue-html2pdf
            :show-layout="false"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1400"
            :filename="`Mandatos-${date_init_formated}-${date_end_formated}`"
            :pdf-quality="2"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="780px"
            @progress="onProgress($event)"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf"
          >
            <section
              class="ml-3"
              slot="pdf-content"
              style="font-family: Helvetica, Arial, sans-serif;"
            >
              <section style="font-family: Helvetica, Arial, sans-serif;" class="pdf-item">
                <v-layout row wrap white pb-2 mr-4 mb-5 mt-4>
                  <v-flex xs2>
                    <v-img :src="logo.src" class="mr-2 mt-1" height="auto" :alt="logo.title" />
                  </v-flex>
                  <v-flex
                    pl-1
                    pt-3
                    title
                    text-xs-left
                    xs12
                    style="border-bottom: 2px solid #c62828;"
                  >Mandatos de síndico</v-flex>

                  <v-flex xs6 pl-1 pb-4 pt-1 mb-2>
                    <h2
                      class="caption text-xs-left pl-0"
                    >PERÍODO: {{`${date_init_formated} a ${date_end_formated}`}}</h2>
                  </v-flex>
                  <v-data-table
                    :headers="headersPdf"
                    :items="mandates"
                    hide-actions
                    style="width=:100%"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-left px-51">{{ props.item.name_fantasy }}</td>
                      <td class="text-xs-left px-51">{{ props.item.reference }}</td>
                      <td class="text-xs-left px-51">{{ props.item.date_init | moment("MM/YYYY") }}</td>
                      <td class="text-xs-left px-51">{{ props.item.date_end | moment("MM/YYYY") }}</td>
                    </template>
                  </v-data-table>
                </v-layout>
                <v-layout row wrap white pb-0 mr-4 pt-3>
                  <v-flex
                    pb-0
                    mb-0
                    pt-2
                    caption
                    text-xs-right
                    xs12
                    style="border-top: 2px solid #c62828; margin-top:610px;"
                  >01</v-flex>
                </v-layout>
              </section>
            </section>
          </vue-html2pdf>
        </v-flex>
      </v-layout>
    </v-form>

    <v-data-table :headers="headers" :items="mandates">
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.name_fantasy }}</td>
        <td class="text-xs-left">{{ props.item.reference }}</td>
        <td class="text-xs-left">{{ props.item.date_init | moment("MM/YYYY") }}</td>
        <td class="text-xs-left">{{ props.item.date_end | moment("MM/YYYY") }}</td>
      </template>
      <template v-slot:no-data>
        <p>Não há dados</p>
      </template>
    </v-data-table>
    <v-dialog v-model="loaderDialog" hide-overlay persistent width="300">
      <v-card color="blue darken-1" dark>
        <v-card-text>
          Gerando PDF {{buildStatus}}%
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import * as moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'
export default {
  components: {
    VueHtml2pdf
  },
  data () {
    return {
      loaderDialog: false,
      logo: {
        restrictedarea: 'Área restrita',
        src: './img/logo.png',
        title: 'InSight Síndicos',
        txt: 'Faça login para acessar o sistema.'
      },
      buildStatus: 0,
      validForm: true,
      date_init: '',
      date_end: '',
      initDateMenu: false,
      endDateMenu: false,
      condominium_id: '',
      headers: [
        { text: 'Condomínio', value: 'name_fantasy' },
        { text: 'Referência', value: 'reference' },
        { text: 'Data de início', value: 'date_init' },
        { text: 'Data final', value: 'date_end' }
      ],
      headersPdf: [
        {
          text: 'Condomínio',
          value: 'name_fantasy',
          sortable: false,
          class: 'px-51'
        },
        {
          text: 'Referência',
          value: 'reference',
          sortable: false,
          class: 'px-51'
        },
        {
          text: 'Data de início',
          value: 'date_init',
          sortable: false,
          class: 'px-51'
        },
        {
          text: 'Data final',
          value: 'date_end',
          sortable: false,
          class: 'px-51'
        }
      ],
      mandates: []
    }
  },
  props: {
    condominiumsList: Array
  },
  computed: {
    date_init_formated: {
      get () {
        return this.date_init ? moment(this.date_init).format('MM/YYYY') : ''
      },
      set (value) {
        if (value) {
          if (value.length < 7) return
          this.date_init = moment(`${value.split('/')[0]}/${value}`).format(
            'YYYY-MM'
          )
        } else {
          this.date_init = ''
        }
      }
    },
    date_end_formated: {
      get () {
        return this.date_end ? moment(this.date_end).format('MM/YYYY') : ''
      },
      set (value) {
        if (value) {
          if (value.length < 7) return
          this.date_end = moment(`${value.split('/')[0]}/${value}`).format(
            'YYYY-MM'
          )
        } else {
          this.date_end = ''
        }
      }
    }
  },
  watch: {
    buildStatus (v) {
      console.log(v)
      if (v > 0 && v < 100) {
        this.loaderDialog = true
      } else {
        this.loaderDialog = false
      }
    }
  },
  methods: {
    checkType (data) {
      return typeof data.item !== 'object'
    },
    hasGenerated (a) {
      console.log(a)
    },
    onProgress (d) {
      this.buildStatus = d
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },
    // generateReport() {
    //   const qs = require("qs");
    //   let lastDay = moment(this.date_end).daysInMonth();
    //   let dataSearch = {
    //     date_init: this.date_init + "-01",
    //     date_end: `${this.date_end}-${lastDay}`,
    //     condominium_id: this.condominium_id,
    //   };
    //   let params = {
    //     ...dataSearch,
    //   };
    //   let dataQuery = `?${qs.stringify(params)}`;
    //   let obj = {
    //     url: "/api/pdf/mandate_pdf" + dataQuery,
    //     query: "",
    //     method: "get",
    //   };
    //   this.$store.dispatch("request/doRequest", obj).then((response) => {
    //     //window.open(response.data);
    //     var byteCharacters = atob(response.data);
    //     var byteNumbers = new Array(byteCharacters.length);
    //     for (var i = 0; i < byteCharacters.length; i++) {
    //       byteNumbers[i] = byteCharacters.charCodeAt(i);
    //     }
    //     var byteArray = new Uint8Array(byteNumbers);
    //     var file = new Blob([byteArray], { type: "application/pdf;base64" });
    //     var fileURL = URL.createObjectURL(file);
    //     window.open(fileURL);
    //   });
    //   // window.open(
    //   //   `http://sistema-dev.insindicos.com.br/v1/api/pdf/mandate_pdf${dataQuery}`,
    //   //   "_blank"
    //   // );
    // },
    searchMandates () {
      if (!this.$refs.sindicateMandateForm.validate()) {
        setTimeout(() => {
          this.$refs.sindicateMandateForm.resetValidation()
        }, 2000)
        return
      }

      let dataSearch = {}
      let lastDay = moment(this.date_end).daysInMonth()
      dataSearch.params = {
        date_init: this.date_init + '-01',
        date_end: `${this.date_end}-${lastDay}`,
        condominium_id: this.condominium_id
      }
      let obj = {
        url: '/api/syndicationMandate',
        query: dataSearch,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.mandates = response.data
      })
    }
  }
}
</script>
<style>
td.px-51,
th.px-51 {
  padding-left: 60px !important;
  padding-right: 60px !important;
}
.autocomplete-text-truncate-class {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
